import React from 'react';
import { useParams } from 'react-router-dom';
import { usePageClassName } from '../hooksInternal/usePageClassName';
const ExtraPage = ({ page }) => {
    const params = useParams();
    usePageClassName('generic-page');
    const Page = page;
    return React.createElement(Page, { ...params });
};
export default ExtraPage;
//# sourceMappingURL=extra.js.map